import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { QueovalParam, BreadcrumbModel, EventsModel, Stage, Apprenant, BObjectModel, BreadDik, ReservationData, eAppContext } from '../../models';
import { BreadcrumbService, CoreService, HttpService, QueovalDateService } from '../../services';
import { DialogService } from '../../dialog';
import { Subscription } from 'rxjs';
import { AgendaQueovalService } from '../agenda.queoval.services';
import { ToastService } from '../../toast';
import { isEmptyStr } from '../../utilities';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-reservation-formateur',
  templateUrl: './reservationformateur.component.html',
  styleUrls: ['./reservationformateur.component.css']
})

export class ReservationFormateurComponent implements OnInit, OnDestroy {

  public param: QueovalParam;
  // #region VARIABLES GLOBALES
  public BOAdress: BObjectModel;
  public Stages: Stage[];
  public Apprenants: Apprenant[];
  public globalSaveStage: boolean = false;
  public ShowRemoveButton: boolean = false;
  public ShowSaveButton: boolean = false;

  public globalPresence: string = "";
  public deletingSignature: boolean = false;
  public reloadEmargementFormateur: boolean = false;
  public EmargementFormateurExist: boolean = false;

  public zoom: boolean = false;
  private openZoom: boolean = false;
  public disableSelect: boolean;
  public selectedStage: string;
  public loaded: boolean;
  public baseModel: EventsModel;
  private Arraysub: Array<Subscription> = new Array<Subscription>();

  public signatureAllowed: boolean = false;
  // #endregion

  @Input('param') _param: QueovalParam;

  /**
   * Ident du stage
   */
  @Input()
  set IdStage(value: string) {
    if (!isEmptyStr(value)) {
      this.setStage(value);
    }
  }

  @Output() sendEvent: EventEmitter<BreadcrumbModel> = new EventEmitter<BreadcrumbModel>();
  @ViewChild('closeDelete', { static: false }) closeDelete: ElementRef;
  constructor(
    private dialogservice: DialogService,
    public indParam: CoreService,
    private httpService: HttpService,
    public agenda: AgendaQueovalService,
    private toast: ToastService,
    public qDateService: QueovalDateService,
    public sanitize: DomSanitizer,
    private breadcrumbservice: BreadcrumbService,
  ) { }

  ngOnInit(): void {
    this.globalSaveStage = false;
    this.ShowRemoveButton = JSON.parse(JSON.stringify(this._param.model.ShowRemoveButton));
    this.ShowSaveButton = JSON.parse(JSON.stringify(this._param.model.ShowSaveButton));
    this.param = JSON.parse(JSON.stringify(this._param));
    this.param.model.ShowRemoveButton = false;
    this.param.model.ShowSaveButton = false;
    const code: BreadDik[] = this.param.params.filter((element: BreadDik) => element.key === 'code');
    const codeValue: string = code.length > 0 ? code[0].value : '';
    const userId: BreadDik[] = this.param.params.filter((element: BreadDik) => element.key === 'userId');
    const strUserId: string = userId && userId.length > 0 ? userId[0].value : '';
    const trainingId: BreadDik[] = this.param.params.filter((element: BreadDik) => element.key === 'trainingId');
    const strTainingId: string = trainingId && trainingId.length > 0 ? trainingId[0].value : '';

    this.Arraysub.push(this.httpService.getHttp<EventsModel>(`${this.indParam.AppParams.apiUrl}api/Events/GETINIT/${this.param.model.IdDonneeFils}|${codeValue}|${this.param.model.IdRelation}|${strUserId}`).subscribe((data: EventsModel) => {
      if (!data.HasError) {
        this.signatureAllowed = data.SignatureAllowed;
        this.baseModel = data;
        this.baseModel.DataReservation = data.DataReservation !== null ? data.DataReservation : new ReservationData();
        this.dialogservice.showSplash(false);
        this.BOAdress = data.Lieu;
        // Affectation de la liste des stages (et si on n'a pas désactivé le sélect avant)
        this.Stages = (data.ListStage && data.ListStage.length > 0) && !this.disableSelect ? data.ListStage : this.Stages;
        // Get stage rattaché a la reservation
        if (strTainingId && strTainingId != '0') {
          this.selectedStage = strTainingId;
          this.disableSelect = true;
        }

        if (this.param.model.IdDonneeFils !== '0') {
          this.Arraysub.push(this.httpService.getHttp<EventsModel>(`${this.indParam.AppParams.apiUrl}api/Events/GetStageByReservation/${this.param.model.IdDonneeFils}`).subscribe((data: EventsModel) => {
            if (!data.HasError) {
              this.dialogservice.showSplash(false);
              this.Stages = data.ListStage && data.ListStage.length > 0 ? data.ListStage : this.Stages;
              if (this.Stages && this.Stages.length > 0) {
                // load apprenant sur le stage
                this.selectedStage = this.Stages[0].BOModel.IdDonneeFils;
                //this.disableSelect = true;
                this.OnstageChange();
              }
            }
            this.dialogservice.showSplash(false);
          }));
        }
      }
    }));

  }

  ngOnDestroy(): void {
    this.Arraysub.forEach((sub: Subscription) => {
      sub.unsubscribe();
    });
  }

  // #region FONCTIONS PUBLIQUES
  // Btn de save general de la page
  public SaveResa(): void {
    if (!(this.param.model as BObjectModel).IdDonneePere || (this.param.model as BObjectModel).IdDonneePere === '0') {
      this.toast.showInfoToast('veuillez affecter la réservation à un collaborateur.');
      return;
    }
    this.globalSaveStage = false;
    setTimeout(() => {
      this.globalSaveStage = true;
    }, 0);
  }

  public pageLoaded(): void {
    setTimeout(() => { this.zoom = document.getElementById('BtnZoom') ? true : false; }, 0);
  }

  public saveResaAndOpenZoom(): void {
    if (!(this.param.model as BObjectModel).IdDonneePere || (this.param.model as BObjectModel).IdDonneePere === '0') {
      this.toast.showInfoToast('veuillez affecter la réservation à un collaborateur.');
      return;
    }
    this.openZoom = true;
    this.globalSaveStage = false;
    setTimeout(() => {
      this.globalSaveStage = true;
    }, 0);
  }

  // Link du stage sur la reservation apres la sauvgarde de la reservation
  public getIdBoRdv(BOEvent: any): void {
    if (BOEvent && BOEvent.Error !== 'NOTVALID') {
      BOEvent.ShowRemoveButton = JSON.parse(JSON.stringify(this.ShowRemoveButton));
      BOEvent.ShowSaveButton = JSON.parse(JSON.stringify(this.ShowSaveButton));
      if (this.globalSaveStage) {

        this.dialogservice.showSplash(true);
        this.globalSaveStage = false;
        // tslint:disable-next-line:max-line-length
        this.Arraysub.push(this.httpService.getHttp<EventsModel>(`${this.indParam.AppParams.apiUrl}api/Events/SaveRdvFormateur/${BOEvent.IdDonneeFils}|${this.selectedStage}`).subscribe((dataStg: EventsModel) => {
          if (!dataStg.HasError) {
            dataStg.ListApprenant = this.Apprenants;
            dataStg.Ident = BOEvent.IdDonneeFils;
            dataStg.Mode = 'UpdatePresence';
            this.Arraysub.push(this.httpService.postHttp<EventsModel>(`${this.indParam.AppParams.apiUrl}api/Events/`, dataStg).subscribe((dataPres: EventsModel) => {
              if (!dataPres.HasError) {
                // Message succes + redirection
                if (this.openZoom) {
                  const p: Array<BreadDik> = new Array<BreadDik>();
                  p.push(new BreadDik('params', ''));
                  const param: { params: Array<BreadDik>, model: BObjectModel } = { params: p, model: BOEvent };
                  const breadCrumbItem: BreadcrumbModel = new BreadcrumbModel('', 'zoom', param, 'Salle Virtuelle', true);
                  switch (this.indParam.AppParams.context) {
                    case eAppContext.QUEOVAL:
                      breadCrumbItem.link = `view/agenda/agendazoom`;
                      break;
                    case eAppContext.EXTRANET:
                      breadCrumbItem.link = `webform/agenda/extranet-agendazoom`;
                      break;
                  }
                  this.breadcrumbservice.changeContext(breadCrumbItem);
                } else {
                  this.sendEvent.emit(new BreadcrumbModel('back', '', null, '', false));
                }
              }
              this.dialogservice.showSplash(false);
            }));
          } else {
            this.dialogservice.showSplash(false);
          }
        }));
      }
    } else {
      this.globalSaveStage = false;
      this.openZoom = false;
      this.dialogservice.showSplash(false);
    }
  }

  public UpdatePresence(value: string, apprenant: Apprenant): void {
    if (apprenant.presence === value) {
      apprenant.presence = '';
    } else {
      apprenant.presence = value;
    }
    if (!this.presencesHaveSameValues()) {
      this.globalPresence = "";
    } else {
      this.globalPresence = apprenant.presence;
    }
  }

  public setRadio(value: string): void {
    if (this.globalPresence === value) {
      this.Apprenants.forEach((i: Apprenant) => i.presence = "");
      this.globalPresence = "";
    } else {
      this.Apprenants.forEach((i: Apprenant) => i.presence = value);
      this.globalPresence = value;
    }
  }

  public presencesHaveSameValues(): boolean {
    for (let i: number = 0; i < this.Apprenants.length; i++) {
      const stage: Apprenant = this.Apprenants[i];
      if (stage.presence !== this.Apprenants[0].presence) {
        return false;
      }
    }
    return true;
  }

  // Fermeture de la modale de suppression
  public closeModalDelete(): void {
    this.closeDelete.nativeElement.click();
  }

  // Confirmation de la suppression du rendez-vous
  public confirmDelete(): void {
    const model: EventsModel = this.baseModel;
    this.dialogservice.showSplash(true);
    model.Mode = 'DELETERESA';
    this.httpService.postHttp<EventsModel>(`${this.indParam.AppParams.apiUrl}api/Events/`, model).subscribe((data: EventsModel) => {
      if (!data.HasError) {
        this.baseModel = data;
        this.dialogservice.showSplash(false);
        if (data.Alert && data.Alert !== '') {
          this.toast.showWarningToast(data.Alert);
        } else {
          // Message succes + redirection
          this.closeModalDelete();
          this.sendEvent.emit(new BreadcrumbModel('back', '', null, '', false));
          this.toast.showSuccessToast('Rendez-vous supprimé');
        }
      }
    });
  }

  // Load liste des apprenants sur le stage
  public OnstageChange(): void {
    this.dialogservice.showSplash(true);
    // tslint:disable-next-line:max-line-length
    this.Arraysub.push(this.httpService.getHttp<EventsModel>(`${this.indParam.AppParams.apiUrl}api/Events/GetApprenant/${this.param.model.IdDonneeFils}|${this.selectedStage}`).subscribe((data: EventsModel) => {
      if (!data.HasError) {
        this.Apprenants = data.ListApprenant;

        if (this.Apprenants.length > 0) {
          if (!this.presencesHaveSameValues()) {
            this.globalPresence = "";
          } else {
            this.globalPresence = this.Apprenants[0].presence;
          }
        }
        this.dialogservice.showSplash(false);
      }
    }));
  }

  public DeleteStgSignature(idPere: string, idFils: string, codeRelation: string, Apprenant: Apprenant | null = null): void {
    this.deletingSignature = true;
    if (!Apprenant) {
      this.reloadEmargementFormateur = true;
    }
    this.httpService.getHttp<EventsModel>(`${this.indParam.AppParams.apiUrl}api/signature/DELETE_SIGNATURE/${idPere}|${idFils}|${codeRelation}`).subscribe((data: EventsModel) => {
      if (!data.HasError) {
        if (Apprenant) {
          Apprenant.infoEmargement = '';
          Apprenant.pathEmargement = '';
        }
        this.reloadEmargementFormateur = false;
      }
      this.deletingSignature = false;
    });
  }

  // #endregion

  // #region private function

  private setStage(idStage: string): void {
    this.dialogservice.showSplash(true);
    this.httpService.getHttp<EventsModel>(`${this.indParam.AppParams.apiUrl}api/Events/GETSTAGE/${idStage}`).subscribe((data: EventsModel) => {
      if (!data.HasError) {
        this.dialogservice.showSplash(false);
        this.Stages = data.ListStage && data.ListStage.length > 0 ? data.ListStage : this.Stages;
        if (this.Stages && this.Stages.length > 0) {
          this.selectedStage = idStage;
          this.disableSelect = true;
          this.OnstageChange();
        }
      }
      this.dialogservice.showSplash(false);
    });
  }

  // #endregion

}

